import { AppBar, Grid, Hidden, Toolbar, Typography } from '@material-ui/core';
import React from 'react';

interface IProps {
  title: string;
}

const GroupVisitHeader: React.FC<IProps> = ({ title }) => {
  return (
    <AppBar position='absolute'>
      <Toolbar>
        <Grid container spacing={2} alignItems='center'>
          <Grid item>
            <Hidden smUp>
              <img
                src={process.env.PUBLIC_URL + '/assets/logos/logo-white.png'}
                alt='Sloan Longway logo'
                width='100'
              />
            </Hidden>
            <Hidden xsDown>
              <img
                src={process.env.PUBLIC_URL + '/assets/logos/logo-white.png'}
                alt='Sloan Longway logo'
                width='180'
              />
            </Hidden>
          </Grid>

          <Grid item style={{ textAlign: 'center' }}>
            <Hidden smUp>
              <Typography variant='subtitle1'>{title}</Typography>
            </Hidden>
            <Hidden xsDown>
              <Typography variant='h4'>{title}</Typography>
            </Hidden>
          </Grid>
        </Grid>
      </Toolbar>
    </AppBar>
  );
};

export default GroupVisitHeader;
